module.exports = __webpack_public_path__ + "static/media/Cornerstone-Logo.821ab1a8.svg";